import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type TrainingDocument = {
   docid: number;
   doctype: 'guide' | 'wiki';
};

export type SkillsMatrixOptions = {
   userids?: Array<number>;
   docs?: Array<TrainingDocument>;
   courseid?: number;
   teamid?: number;
};

export type SkillsMatrixUser = {
   userid: number;
   name: string;
   image: string;
   hasCustomAvatar: boolean;
   average_score: number;
};

export type UserSkillRating = {
   userid: number;
   skill_rating: number;
};

export type SkillsMatrixDocument = TrainingDocument & {
   title: string;
   users: Array<UserSkillRating>;
};

export type SkillsMatrix = {
   supervisorRatingsEditableByCurrentUser: boolean;
   users: Array<SkillsMatrixUser>;
   docs: Array<SkillsMatrixDocument>;
};

export function getSkillsMatrix(
   skillsMatrixBody: SkillsMatrixOptions,
   common: CommonRequestOptions = {}
): Promise<SkillsMatrix> {
   return makeRequest('post', `/skills/matrix`, {
      ...common,
      body: skillsMatrixBody,
   });
}
